<template>
  <FormulateInput type="text" v-model="model" v-bind="$attrs" inputmode="numeric" @input="setValue">
    <template #suffix>
      <div class="formulate-input-suffix">
        <Icon name="input-euro" :size="15" />
        {{ suffix }}
      </div>
    </template>
  </FormulateInput>
</template>

<script>
import Icon from '@/lego/components/icons/Icon.vue';
import { ref, toRefs, watch } from '@vue/composition-api';

export default {
  components: { Icon },
  props: {
    value: {
      type: String | Number,
    },
    locale: {
      type: String,
      default: 'es-ES',
    },
    suffix: {
      type: String,
      required: false,
    },
    max: {
      type: Number,
      default: 20000000,
    },
  },
  setup(props, { root, emit }) {
    const model = ref(null);
    const { value } = toRefs(props);

    const setValue = function(v) {
      var val = parseInt(v?.toString().replace(/[^0-9]/g, ''));

      if (isNaN(val) || val === 0) {
        model.value = '';
        emit('input', '');

        return;
      }

      if (val > props.max) {
        val = props.max;
      }

      model.value = val.toLocaleString(props.locale);

      emit('input', val.toString());
    };

    watch(value, val => setValue(val));

    setValue(value.value);

    return {
      setValue,
      model,
      props,
    };
  },
};
</script>

<style lang="postcss" scoped>
/deep/ .formulate-input {
  &-element {
    @apply flex items-center border-solid border-hairline border-neutral-semilight rounded-md;

    &--group {
      @apply flex flex-col gap-micro;
    }
    [data-is-showing-errors='true']& {
      @apply border-feedback-error-medium;
    }
  }
  &-suffix {
    @apply px-nano py-micro style-body-sm flex items-center;
  }
  &-errors {
    @apply style-overline text-feedback-error-medium mt-nano m-0 p-0 list-none;
  }
}
.formulate-input::v-deep {
  input {
    @apply w-full px-quark border-none text-neutral-ultradark py-micro disabled:bg-neutral-lightest style-body-sm focus:outline-none;
  }
}
</style>
